var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('div',{staticClass:"header clearfix"},[_c('div',{staticClass:"title"},[_c('h1',{staticClass:"title__heading"},[_vm._t("title")],2)]),_c('div',{staticClass:"functional__wrapper"},[_c('Support'),_c('User')],1)])]),_c('el-main',[_c('div',{staticClass:"main"},[_vm._t("main")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }